import { Dumbbell, Salad, Brain, Sunrise, Wind, Flame, Users } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";
import { OTT_COACHES } from "../../data/content";

const ICONS = { Dumbbell, Salad, Brain, Sunrise, Wind, Flame, Users };

export const OTTPlatform = () => {
  return (
    <section id="platform" className="relative bg-[#0b1528] py-24 sm:py-32 px-5 sm:px-8 overflow-x-hidden" data-testid="ott-platform-section">
      <div className="max-w-7xl mx-auto overflow-x-hidden">
        <ScrollReveal>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">
            Now Streaming
          </span>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl text-white mt-4 max-w-3xl leading-tight">
            Health &amp; Wellness. Now Streaming. Anytime, Anywhere.
          </h2>
          <p className="text-slate-400 text-sm sm:text-base mt-4 max-w-2xl">
            Just like entertainment platforms give you unlimited access to movies and shows —
            MindBodyLife.pro gives you access to something even more valuable: your health.
          </p>
        </ScrollReveal>

        <div className="mt-14 flex gap-4 overflow-x-auto pb-4 -mx-5 px-5 sm:mx-0 sm:px-0 sm:grid sm:grid-cols-3 lg:grid-cols-4 sm:gap-5 [&::-webkit-scrollbar]:hidden">
          {OTT_COACHES.map((coach, i) => {
            const Icon = ICONS[coach.icon];
            return (
              <ScrollReveal
                key={coach.title}
                delay={i * 0.06}
                className="relative shrink-0 w-[220px] sm:w-auto aspect-[3/4] rounded-2xl overflow-hidden group cursor-pointer"
                data-testid={`ott-card-${coach.title.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <img
                  src={coach.img}
                  alt={`${coach.title} inside MindBodyLife.pro`}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/40 to-transparent" />
                <div className="absolute inset-0 border border-cyan-500/0 group-hover:border-cyan-500/50 rounded-2xl transition-colors duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <Icon size={18} className="text-cyan-400 mb-2" />
                  <h3 className="font-display font-bold text-sm sm:text-base text-white leading-tight">
                    {coach.title}
                  </h3>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
